import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ParseKeys } from 'i18next';

export type TitleKey = 'cahierJournal' | 'emploiDuTemps';

type I18nTitleKey = Extract<
  ParseKeys<'common', {}, undefined>,
  `sidebar.${string}`
>;

export function TitleHelmet({ titleKey }: { titleKey: I18nTitleKey }) {
  const { t } = useTranslation(['common']);
  return (
    <Helmet>
      <title>{t(titleKey)}</title>
    </Helmet>
  );
}
